var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.settings.device==='desktop')?_c('font-awesome-icon',{staticClass:"svg desktop",style:({ color: '#212426' }),attrs:{"icon":"desktop"}}):_vm._e(),(_vm.settings.device==='mobile')?_c('font-awesome-icon',{staticClass:"svg mobile",style:({ color: '#212426' }),attrs:{"icon":"mobile-alt"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }